import { Button, Flex, IconWrap, Text } from "@coaching-culture/ui";
import { useUser } from "auth";
import { FaBan, FaSignOutAlt } from "react-icons/fa";
import { Redirect } from "react-router";

export const DeactivatedUser = () => {
  const [user, setUser] = useUser();

  const logout = () => {
    setUser(null);
  };

  if (!user.isDeactivated) {
    return <Redirect to="/" />;
  }

  return (
    <Flex
      alignItems="center"
      justifyContent="center"
      width="100vw"
      height="100vh"
      flexDirection={"column"}
      pb={5}
      backgroundColor="#ddd"
    >
      <Flex maxWidth={550} flexDirection="column" alignItems={"center"}>
        <IconWrap color="danger" icon={FaBan} fontSize="8em" />
        <Text fontSize={6} mt={3} fontWeight={400}>
          This user has been deactivated
        </Text>
        <Text fontSize={4} textAlign="center" mb={3}>
          This user account has been deactivated by an administrator and can no
          longer use the Coaching Culture Platform.
        </Text>
        <Text fontSize={4} textAlign="center" fontWeight={600} mb={5}>
          If you feel this is an error, please contact your system administrator
        </Text>
        <Button onClick={logout} icon={FaSignOutAlt} color="primary">
          Logout
        </Button>
      </Flex>
    </Flex>
  );
};
